export class Overlay {
}

Overlay.$show = (iParam) => {
    let text = iParam && iParam.text ? iParam.text : _l("Chargement en cours, veuillez patienter");
    const $overlay=$("<div/>").attr({"id":"overlay"}).addClass("wait_overlay").appendTo($("html"));
        $("<div/>").addClass("label").text(text).appendTo($overlay);
}

Overlay.hide = (iParam) => {
    $("#overlay").remove();
}